import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import { ContentCourseRepeatRateListService } from '../../services/ContentListService';
import { get } from 'lodash';
import { englishLevelCourses } from '../../../../../core/consts';
import ContentCourseRepeatRateTable from './ContentCourseRepeatRateTable';

class ContentCourseRepeatRateTableContainer extends React.Component {
  componentDidMount() {
    ContentCourseRepeatRateListService.load(
      this.props.unitId ? 'unit' : this.props.moduleId ? 'module' : 'course',
      this.props.unitId || this.props.moduleId || this.props.courseId
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.unitId !== prevProps.unitId ||
      this.props.moduleId !== prevProps.moduleId ||
      this.props.courseId !== prevProps.courseId
    ) {
      ContentCourseRepeatRateListService.load(
        this.props.unitId ? 'unit' : this.props.moduleId ? 'module' : 'course',
        this.props.unitId || this.props.moduleId || this.props.courseId
      );
    }
  }

  render() {
    return (
      <ContentCourseRepeatRateTable
        loading={
          ContentCourseRepeatRateListService.fetchCurrent.fetching ||
          ContentCourseRepeatRateListService.fetchPrevious.fetching
        }
        values={toJS(ContentCourseRepeatRateListService.getList()).map((item) =>
          Object.assign({}, item, {
            level: get(
              englishLevelCourses.find((c) => c.label === item.name),
              'value',
              null
            ),
          })
        )}
        nameColumnPath={this.props.courseId || this.props.moduleId || this.props.unitId ? 'order' : 'level'}
        nameColumnRender={(row) => {
          if (this.props.unitId) {
            return `${row.order} - ${ContentCourseRepeatRateListService.getGroupLabel(row.group)} - ${row.type}`;
          } else if (this.props.courseId || this.props.moduleId) {
            return `${row.group} - ${row.order} - ${row.name}`;
          } else {
            return row.name;
          }
        }}
        onSelect={(row) => {
          if (this.props.unitId) {
            return false;
          }
          if (this.props.moduleId) {
            browserHistory.push(
              `/kpis/content/course/${this.props.courseId}/module/${this.props.moduleId}/unit/${row.id}/details`
            );
          } else if (this.props.courseId) {
            browserHistory.push(`/kpis/content/course/${this.props.courseId}/module/${row.id}/details`);
          } else {
            browserHistory.push(`/kpis/content/course/${row.id}/details`);
          }
        }}
        formatter={ContentCourseRepeatRateListService.getFormattedValue}
        feedbackColorRender={ContentCourseRepeatRateListService.getFeedbackColor}
      />
    );
  }
}

ContentCourseRepeatRateTableContainer.propTypes = {
  courseId: PropTypes.string,
  moduleId: PropTypes.string,
  unitId: PropTypes.string,
};

export default observer(ContentCourseRepeatRateTableContainer);
